// extracted by mini-css-extract-plugin
export default {"mCard":"pB-z","image":"qB-z","imageNoBackground":"rB-z","imageHasCategory":"sB-z","fullWidth":"tB-z"};